export const TENANT = 'root';

export const Token_ExpiresIn = 20150; //minutes
export  const RefreshToken_ExpireIn = 20;